import { render, staticRenderFns } from "./simpleSalesScreenMobile.vue?vue&type=template&id=15a735a0&scoped=true"
import script from "./simpleSalesScreenMobile.vue?vue&type=script&lang=js"
export * from "./simpleSalesScreenMobile.vue?vue&type=script&lang=js"
import style0 from "./simpleSalesScreenMobile.vue?vue&type=style&index=0&id=15a735a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a735a0",
  null
  
)

export default component.exports